import React from "react";
import "./ClientChart.css";
import { Doughnut } from "react-chartjs-2";
import { Tag,Spin } from "antd";

const ClientChart = ({ data,isActionLoading }) => {
  const centerTextPlugin = {
    id: "centerText",
    afterDraw: (chart) => {
      const { ctx, width, height } = chart;
      var text = chart.config.data.text;
      var sidePadding = 20;
      var sidePaddingCalculated = (sidePadding / 100) * (chart.innerRadius * 2);
      ctx.font = "bold 40px " + "Arial";
      //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
      var stringWidth = ctx.measureText(text).width;
      var elementWidth = chart.innerRadius * 2 - sidePaddingCalculated;
      // Find out how much the font can grow in width.
      var widthRatio = elementWidth / stringWidth;
      var newFontSize = Math.floor(30 * widthRatio);
      var elementHeight = chart.innerRadius * 2;

      // Pick a new font size so it will not be larger than the height of label.
      var fontSizeToUse = Math.min(newFontSize, elementHeight);

      var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
      var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;

      var fontSize = (height / 114).toFixed(2);
      ctx.font = fontSize + "em Verdana";
      ctx.textBaseline = "middle";

      ctx.textAlign = "center";
      ctx.font = fontSizeToUse + 3 + "px " + "Arial";

      var textX = Math.round((width - ctx.measureText(text).width) / 2);
      var textY = height / 2;

      ctx.fillText(text, centerX, centerY);
    },
  };
  const assets = (data && +data.netWorth) || 0;
  const liabilities = (data && +data.totalLiabilitySum) || 0;
  const credit = (data && +data.totalCreditSum) || 0;

  const netWorth = assets - (liabilities + credit) || 0;
  const liabilitiesTotal = liabilities + credit || 0;

  const labels = data && [
    `Assets: $${assets.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    `Liabilities: $${liabilitiesTotal
      .toFixed(2)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    `Net Worth: $${(isNaN(netWorth) ? 0 : netWorth)
      .toFixed(2)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
  ];
  const dataValues = data && [
    assets ? assets : 0,
    liabilitiesTotal ? liabilitiesTotal : 0,
    netWorth ? netWorth : 0,
  ];

  const isClientActive = data && data.isActive;

  // console.log("dataValues",dataValues,liabilities,credit,assets,netWorth)
  return (
    <div className="clientChartCard">
     {isActionLoading && (
            <div className="action-loading-overlay">
              <Spin size="large" />
            </div>
          )}
      <h1
        className="clientCardHeading"
        // style={{
        //   borderBottom: "1px solid rgba(236, 236, 236, 1)",
        //   paddingBottom: "1rem",
        // }}
      >
        <div className="footerItems">
          <span className="footerItemTitle">Client Name</span>
          <div className="headerTitleSection">
            <div className="statusIndicator">
              <span
                className={`statusDot ${
                  isClientActive ? "active" : "inactive"
                }`}
              ></span>
            </div>
            <h1 className="clientDetailsHeading">
              {data && data.client && data.client.name
                ? data.client.name
                : "Client"}
            </h1>
            <Tag
              color={isClientActive ? "#52c41a" : "#ff4d4f"}
              style={{ marginLeft: "12px", fontSize: "12px" }}
            >
              {isClientActive ? "Active" : "Inactive"}
            </Tag>
          </div>
        </div>
      </h1>
      {/* <Divider /> */}
      <div
        className="chartContainer"
        // style={{ height: "150px", width: "80%", position: "relative" }}
      >
        <Doughnut
          data={{
            labels: labels && labels,
            datasets: [
              {
                label: "Client Chart Values",
                data: dataValues && dataValues,
                // backgroundColor: chartColors,
                backgroundColor: ["#09A84D", "#E53E3E", "#2A3DA3"],
              },
            ],
            text: `${
              data && netWorth != null && assets != null && assets !== 0
                ? `${((netWorth / assets) * 100).toFixed(2)}%`
                : "0.00%"
            }`,
            // text: `${
            //   data && netWorth != null && netWorth !== 0 && assets != null
            //     ? `${((netWorth / assets) * 100).toFixed(2)}%`
            //     : "0.00%"
            // }`,
          }}
          options={{
            //   cutoutPercentage: 70,
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: true,
                position: "right",
              },
            },
            legend: {
              display: true,
              position: "right",
            },
          }}
          plugins={[centerTextPlugin]}
        />
      </div>
    </div>
  );
};

export default ClientChart;
